var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-img",style:(_vm.styles)},[(_vm.bankCode)?_c('img',{attrs:{"src":_vm.img(("banks/" + _vm.bankCode + ".png")),"width":_vm.width}}):_c('img',{attrs:{"src":_vm.img('banks/empty.png'),"width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }